import { Navigate, Route, Routes } from 'react-router-dom';
import useAccountPermission from '@elementary/common-ui/hooks/useAccountPermission';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import AccountSettings from './AccountSettings/AccountSettings';
import AccountTokens from './AccountTokens/AccountTokens';
import Environments from './Environments/Environments';
import Logs from './ActivityLogs/Logs';
import PersonalSettings from './PersonalSettings';
import Settings from './Settings';
import Groups from './Groups/components/Groups';
import Users from './Team/Users';
import Roles from './Roles/components/Roles';
import PersonalTokens from './PersonalTokens/PersonalTokens';
import GPGKeys from './GPGKeys/GPGKeys';
import AiSettings from './AiSettings/AiSettings';
import Runtimes from './Runtimes';
import RuntimeDetails from './Runtimes/RuntimeDetails';

const SettingsPage = () => {
  const hasAccountPermission = useAccountPermission();
  const { data: accountData } = useAccount();

  return (
    <Routes>
      <Route element={<Settings />}>
        <Route path="personal" element={<PersonalSettings />} />
        <Route
          path="profile"
          element={<Navigate to="/settings/personal" replace />}
        />
        <Route path="user-tokens" element={<PersonalTokens />} />
        <Route path="gpg" element={<GPGKeys />} />
        {hasAccountPermission('VIEW_USERS') && (
          <Route path="users" element={<Users />} />
        )}
        {hasAccountPermission('VIEW_ROLES') &&
          accountData?.roles_and_permissions_enabled && (
            <Route path="roles" element={<Roles />} />
          )}
        {hasAccountPermission('VIEW_GROUPS') &&
          accountData?.has_scim_configuration && (
            <Route path="groups" element={<Groups />} />
          )}
        {hasAccountPermission('EDIT_INTEGRATIONS') && (
          <Route path="environments" element={<Environments />} />
        )}
        {hasAccountPermission('EDIT_USERS') && (
          <Route path="account" element={<AccountSettings />} />
        )}
        {hasAccountPermission('EDIT_USERS') && (
          <Route path="account-tokens" element={<AccountTokens />} />
        )}
        {(hasAccountPermission('VIEW_AUDIT_LOGS') ||
          hasAccountPermission('VIEW_SYSTEM_LOGS')) && (
          <Route path="logs" element={<Logs />} />
        )}
        {hasAccountPermission('VIEW_RUNTIMES') &&
          accountData?.runtimes_enabled && (
            <>
              <Route path="runtimes" element={<Runtimes />} />
              <Route path="runtimes/:runtimeId" element={<RuntimeDetails />} />
            </>
          )}
        <Route
          path="ai-usage"
          element={<Navigate to="/settings/ai" replace />}
        />
        <Route path="ai" element={<AiSettings />} />
      </Route>
    </Routes>
  );
};

export default SettingsPage;
